import type { SlideImage } from "yet-another-react-lightbox";

export function Gallery2021(){

  
const slides: SlideImage[] = [
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_001.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_001.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_002.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_002.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_003.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_003.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_004.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_004.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_005.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_005.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_006.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_006.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_007.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_007.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_008.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_008.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_009.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_009.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_010.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_010.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_011.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_011.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_012.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_012.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_013.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_013.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_014.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_014.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_015.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_015.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_016.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_016.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_017.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_017.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_018.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_018.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_019.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_019.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_020.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_020.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_021.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_021.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_022.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_022.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_023.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_023.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_024.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_024.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_025.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_025.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_026.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_026.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_027.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_027.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_028.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_028.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_029.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_029.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_030.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_030.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_031.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_031.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_032.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_032.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_033.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_033.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_034.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_034.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_035.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_035.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_036.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_036.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_037.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_037.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_038.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_038.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_039.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_039.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_040.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_040.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_041.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_041.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_042.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_042.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_043.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_043.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_044.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_044.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_045.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_045.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_046.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_046.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_047.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_047.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_048.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_048.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_049.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_049.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_050.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_050.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_051.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_051.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_052.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_052.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_053.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_053.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_054.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_054.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_055.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_055.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_056.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_056.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_057.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_057.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_058.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_058.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_059.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_059.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_060.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_060.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_061.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_061.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_062.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_062.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_063.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_063.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_064.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_064.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_065.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_065.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_066.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_066.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_067.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_067.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_068.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_068.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_069.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_069.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_070.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_070.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_071.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_071.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_072.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_072.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_073.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_073.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_074.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_074.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_075.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_075.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_076.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_076.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_077.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_077.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_078.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_078.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_079.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_079.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_080.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_080.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_081.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_081.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_082.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_082.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_083.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_083.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_084.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_084.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2021/LRG_085.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2021/SML_085.jpg"
        }
      ];

     return slides;
} 
